// extracted by mini-css-extract-plugin
export var blink = "_94-2";
export var cursor = "_94-1";
export var reactMarkdown = "_94-3";
export var streamingText = "_94-0";